import ParamsStore from "./ParamsStore";

export default class AppStore {
  constructor() {
    this.paramsStore = new ParamsStore();
  }
}



// WEBPACK FOOTER //
// ./src/stores/AppStore.js